function dataURItoBlob(dataURI: string) {

    const byteString = atob(dataURI.split(',')[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([arrayBuffer], { type: 'image/jpeg' });
}

export const base64StringtoFile = (base64String: string | null | undefined, filename: string) => {

    if (base64String) {
        const blob = dataURItoBlob(base64String);
        return new File([blob], filename, { type: blob.type });
    }
}